import { useScrollReveal } from '../../../hooks/useScrollReveal';

interface LinkItem {
  icon: string;
  label: string;
  desc: string;
  url: string;
  isExternal?: boolean;
}

const linkItems: LinkItem[] = [
  {
    icon: 'ri-article-line',
    label: 'ブログ',
    desc: 'Apple製品とガジェットの詳しいレビュー・使い方',
    url: 'https://number84log.com',
    isExternal: true,
  },
  {
    icon: 'ri-bookmark-line',
    label: 'Number84 my items',
    desc: 'SNSで紹介したアイテムをまとめて見られるページ',
    url: 'https://number84log.com/room/',
    isExternal: true,
  },
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    desc: 'Apple製品のTips、ガジェットレビューのショート動画',
    url: 'https://www.instagram.com/__number84/',
    isExternal: true,
  },
  {
    icon: 'ri-twitter-x-line',
    label: 'X',
    desc: '日々の気づき',
    url: 'https://x.com/Number84M',
    isExternal: true,
  },
  {
    icon: 'ri-tiktok-line',
    label: 'TikTok',
    desc: 'Apple製品のTips、ガジェットレビューのショート動画',
    url: 'https://www.tiktok.com/@number84m',
    isExternal: true,
  },
  {
    icon: 'ri-youtube-line',
    label: 'YouTube',
    desc: 'Apple製品のTips、ガジェットレビューのショート動画',
    url: 'https://www.youtube.com/@Number84M',
    isExternal: true,
  },
  {
    icon: 'ri-building-4-line',
    label: '企業向けページ',
    desc: 'お仕事のご依頼・コラボレーションについて',
    url: 'https://number84log.com/request/',
    isExternal: true,
  },
];

export default function LinksSection() {
  const ref = useScrollReveal();

  return (
    <section id="links" className="w-full bg-white py-12 px-6">
      <div ref={ref} className="section-reveal max-w-2xl mx-auto">
        <p className="text-xs font-medium text-[#9A9A9A] tracking-[0.2em] uppercase mb-3">Links</p>
        <div className="w-10 h-px bg-[#E0E0E0] mb-3" />
        <div className="text-xl md:text-2xl font-bold text-[#1A1A1A] tracking-wide mb-10">リンク集</div>

        <div className="space-y-3">
          {linkItems.map((item) => (
            <a
              key={item.label}
              href={item.url === '#contact' ? '#' : item.url}
              target={item.isExternal && item.url !== '#' ? '_blank' : undefined}
              rel={item.isExternal ? 'noopener noreferrer' : undefined}
              className="flex items-center gap-4 bg-white border border-[#EEEEEE] rounded-xl px-5 py-4 hover:bg-[#F8F8F8] hover:border-[#CCCCCC] transition-all duration-200 cursor-pointer group"
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-[20px] text-[#4A4A4A] group-hover:text-[#1A1A1A] transition-colors duration-200`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[15px] font-medium text-[#1A1A1A] tracking-wide">{item.label}</p>
                <p className="text-[12px] text-[#9A9A9A] mt-0.5 truncate">{item.desc}</p>
              </div>
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-[18px] text-[#CCCCCC] group-hover:text-[#6B6B6B] transition-colors duration-200" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
